import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { __API_URL__ } from "../SERVER_URL";

const fetchDocusealTemplates = async () => {
  const token = localStorage.getItem("token");

  const URL = `${__API_URL__}/api/appiell/docuseal_templates/`;

  const res = await axios.get(URL, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useGetDocusealTemplates = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ["docuseal_templates"],
    queryFn: () => fetchDocusealTemplates(),
    enabled: enabled,
    refetchOnWindowFocus: false,
  });
};

export default useGetDocusealTemplates;
